import {createContext, useContext} from 'react';
import {orderStore} from 'store/orderStore';
import {DeliveryMethodEnum, IOrder, OrderProviderType, PaymentMethodEnum} from 'types';

export interface IOrderContext extends OrderProviderType {
  orders: IOrder[];
  ordersActive: IOrder[];
  isLoadingOrders: boolean;
  onHandlerSetLimit: any;
  refetchActiveOrders: () => void;
}

const initialState: OrderProviderType = {
  cutleryNumber: 0,
  instructions: '',
  deliveryMethod: DeliveryMethodEnum.DELIVERY,
  paymentMethod: PaymentMethodEnum.CASH,
  payment_for_self: true,
  tips: 0,
  another_person: {
    name: '',
    phone: '',
  },
};

export const OrderContext = createContext<IOrderContext & orderStore>({
  ...initialState,
  orders: [],
  ordersActive: [],
  isLoadingOrders: false,
  onHandlerSetLimit: () => {},
  refetchActiveOrders: () => {},

  resetState: () => {},
  setDeliveryMethod: () => {},
  setPaymentMethod: () => {},
  setTips: () => {},
  setCutleryNumber: () => {},
  setInstructions: () => {},
  setPaymentForSelf: () => {},
  setAnotherPerson: () => {},
  setPreOrder: () => {},
  setVoucher: () => {},
});

export const useOrderContext = () => {
  const context = useContext(OrderContext);
  if (!context) throw new Error('useOrderContext must be used inside a `OrderProvider`');
  return context;
};
